module.exports = __webpack_public_path__ + "static/img/product-swipe23.ad06c905.png";